import React from "react";
import { Navigate } from "react-router-dom";
import useUserStore from "../../store/userStore"; // Import the Zustand store

interface ProtectedRouteProps {
  element: JSX.Element;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ element }) => {
  const isAuthenticated = useUserStore((state) => state.isAuthenticated);
  //const isAuthenticated =true;
  return isAuthenticated ? element : <Navigate to="/login" />;
};

export default ProtectedRoute;
